<template>
  <div class="marquee-container bg-white border-t border-b border-gray-200 overflow-hidden">
    <div class="marquee-content">
      <div class="marquee-track" :style="{ animationDuration: speed + 's' }" :class="directionClass">
        <div class="marquee-item">
          <template v-for="i in 35" :key="'first-' + i">
            <span class="text-hanken">{{ $t('marquee.light.brand') }}</span>
            <span class="text-cormorant">{{ $t('marquee.light.tagline') }}</span>
          </template>
        </div>
        <div class="marquee-item marquee-item-copy">
          <template v-for="i in 35" :key="'second-' + i">
            <span class="text-hanken">{{ $t('marquee.light.brand') }}</span>
            <span class="text-cormorant">{{ $t('marquee.light.tagline') }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeText',
  props: {
    speed: {
      type: Number,
      default: 90 // segundos para completar uma volta
    },
    direction: {
      type: String,
      default: 'left', // 'left' ou 'right'
      validator: value => ['left', 'right'].includes(value)
    }
  },
  computed: {
    directionClass() {
      return `direction-${this.direction}`
    }
  }
}
</script>

<style scoped>
.marquee-container {
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
}

.marquee-content {
  width: 100%;
  overflow: hidden;
}

.marquee-track {
  display: flex;
  width: fit-content;
  will-change: transform;
  animation-play-state: running;
}

.marquee-track.direction-left {
  animation-name: scroll-left;
  animation-duration: inherit;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.marquee-track.direction-right {
  animation-name: scroll-right;
  animation-duration: inherit;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.marquee-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 3rem;
  flex-shrink: 0;
}

.marquee-item-copy {
  margin-left: 1rem;
}

.marquee-item span {
  font-size: 2.75rem;
  color: #111827;
  letter-spacing: 0;
  margin-right: 1rem;
  flex-shrink: 0;
}

.text-hanken {
  font-family: 'Hanken Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.15em;
}

.text-cormorant {
  font-family: 'Cormorant', Georgia, serif;
  font-weight: 400;
  font-style: italic;
  text-transform: none;
  letter-spacing: 0.05em;
}

@keyframes scroll-left {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes scroll-right {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0%);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .marquee-container {
    height: 70px;
  }
  
  .marquee-item span {
    font-size: 1.75rem;
    margin-right: 1rem;
  }
  
  .marquee-item {
    gap: 2rem;
  }
  
  .marquee-item-copy {
    margin-left: 2.5rem;
  }
}

@media (max-width: 480px) {
  .marquee-container {
    height: 60px;
  }
  
  .marquee-item span {
    font-size: 1.25rem;
    margin-right: 1rem;
  }
  
  .marquee-item {
    gap: 2rem;
  }
  
  .marquee-item-copy {
    margin-left: 1rem;
  }
}

/* Respeitar preferências de redução de movimento */
@media (prefers-reduced-motion: reduce) {
  .marquee-track {
    animation: none;
  }
  
  .marquee-container {
    justify-content: center;
    text-align: center;
  }
  
  .marquee-item-copy {
    display: none;
  }
}
</style> 